import ToggleList from './ToggleList';
import './ToggleList.scss';

export default ToggleList;
